import type { ProductsSuggestionSearchResult } from '@/domains/productDiscovery/HeaderLeonidas/modules/productSuggestions/interfaces/algoliaResponse';

import { PRODUCTS_IN_SEARCHBAR_SLIDER } from '../constants';

export const processStaticProductsResult = (
  staticProducts: ProductsSuggestionSearchResult,
  topProductsResult: ProductsSuggestionSearchResult,
): ProductsSuggestionSearchResult => {
  const { hits: staticHits } = staticProducts;
  const { hits: topHits } = topProductsResult;

  if (staticHits.length >= PRODUCTS_IN_SEARCHBAR_SLIDER) return staticProducts;

  Object.assign(staticProducts, {
    hits: [
      ...staticHits,
      ...topHits.slice(staticHits.length, PRODUCTS_IN_SEARCHBAR_SLIDER),
    ],
  });

  return staticProducts;
};
